import { useMemo } from "react";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";

export const useProjectLabels = () => {
  const { pin, pid } = useGet(active_project);

  const buttonsLabel =
    getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];

  const labelMap = useMemo(() => {
    const map = {};
    for (const btn of buttonsLabel) {
      if (btn?.UILabelProperty) {
        map[btn.UILabelProperty] = btn.Label ?? "";
      }
    }
    return map;
  }, [buttonsLabel]);

  const getLabel = (key, fallback = "") => {
    return labelMap[key] ?? fallback;
  };

  return { getLabel };
};